export default "__VITE_ASSET__Dje6AYbS__"